var _rect, _polygon, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 85.337,
    fill: "#D80027",
    width: 512,
    height: 341.326
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6DA544",
    points: "196.641,85.337 196.641,261.565 196.641,426.663 0,426.663 0,85.337 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDA44",
    cx: 196.641,
    cy: 256,
    r: 64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M160.638,224v40.001c0,19.882,16.118,36,36,36s36-16.118,36-36V224H160.638z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M196.638,276c-6.617,0-12-5.383-12-12v-16h24.001v16C208.638,270.616,203.254,276,196.638,276z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PT.e91f86921c228ded499bba06d8836061.svg";